<style>
</style>
<template>
  <div class="rechargeMsg-box">
    <p class="title">短信管理&nbsp;&nbsp;<strong>[ 充值记录 ]</strong></p>
    <el-table :data="rechargeData" border>
      <el-table-column label="操作人" prop="activeUserName"></el-table-column>
      <el-table-column label="额度变动账号" prop="targerUserName"></el-table-column>
      <el-table-column label="短信变动额度" prop="changeBalance"></el-table-column>
      <el-table-column label="富信变动额度" prop="fuxinChangeBalance"></el-table-column>
      <el-table-column label="变动类型" prop="type"></el-table-column>
      <el-table-column label="变动时间" prop="createtime"></el-table-column>
    </el-table>
    <div class="block mtop20">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size=pageSize
        layout="total, sizes, prev, pager, next, jumper"
        :total=total>
      </el-pagination>
    </div>
  </div>
</template>
<script>
import api from '../../server/api.js'
export default {
  name: "rechargeMsg",
  data(){
    return{
      pageSize: 10,//当前显示条数
      pageNum: 1,//当前页数
      total: 0,//总数
      rechargeData: [],
    };
  },
  created(){
    this.getChargeMsg()
  },
  methods: {
    getChargeMsg(){//获取列表
      let data = {
        "start": this.pageNum,
        "length": this.pageSize,
        // "startTime":
        // "endTime":
        // "activeUserName":
        // "targerUserName":
      }
      api.getBalanceChangeList({data:data}).then(res => {
        if(res.status == 'success'){
          this.rechargeData = res.data.resultList;
          this.total = res.data.count;
        }
      })
    },
    sizeChange(v){//切换显示条数
      this.pageSize = v;
      this.getChargeMsg();
    },
    currentChange(v){//切换页数
      this.pageNum = v;
      this.getChargeMsg();
    },
  },
  components: {
    
  }
}
</script> 
  




// WEBPACK FOOTER //
// src/view/customer/rechargeMsg.vue